import { UserInfoContext } from "Context/CommonContext";
import { FacultyPerformanceContext } from "Context/FacultyPerformanceContext";
import useMasterContext from "Context/MasterContext";
import FacultiesBranchesFilter from "Pages/FacultiesAntd/Branches/FacultiesBranchesFilter";
import FacultiesRegionsFilter from "Pages/FacultiesAntd/Regions/FacultiesRegionsFilter";
import { Badge, Button, Space, Tag } from "antd";
import dayjs from "dayjs";
import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import DrawerAntdComponent from "utilFunctions/shared/AntdSharedComponents/DrawerAntdComponent";
import HeadersComponent from "utilFunctions/shared/AntdSharedComponents/HeadersComponent";
interface FacultiesBranchesHeaderIF {
  filterState: any;
  setFilterState: any;
  open: boolean;
  setOpen: any;
  dates: any;
  setDates: any;
  applyFilter: any;
  pagination: any;
  extraInformation?: any;
  mode: any;
}
const FacultiesBranchesHeader = ({
  filterState,
  setFilterState,
  open,
  setOpen,
  dates,
  setDates,
  applyFilter,
  pagination,
  extraInformation,
  mode,
}: FacultiesBranchesHeaderIF) => {
  const { screen }: any = useWindowSize();
  const { masters } = useMasterContext();
  const { regions, branches, states } = masters;
  const { setFacultyPerformance } = useContext(FacultyPerformanceContext);
  const userInfo = useContext<any>(UserInfoContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isFilterApplied, setIsFilterApplied] = useState<any>(false);
  function getBranchNameByBranchId(inputKey: any): string | undefined {
    if (branches && branches !== undefined) {
      const branch = branches.find((obj: any) => obj.id === inputKey);
      return branch ? branch.label : "";
    } else {
      return "";
    }
  }
  const fetchBranchsHeader = () => {
    const branchId =
      location.pathname.split("/")[location.pathname.split("/").length - 1];
    const regionName = `${getBranchNameByBranchId(parseInt(branchId))} | ${
      pagination.total
    } Faculties`;
    return regionName;
  };
  function getRegionNameByRegionId(
    masterList: any,
    inputKey: any
  ): string | undefined {
    if (masterList && masterList !== undefined) {
      const region = masterList.find((obj: any) => obj.key === inputKey);
      return region ? region.label : "";
    } else {
      return "";
    }
  }
  const fetchStateHeader = () => {
    console.log("sattes", states);
    const stateId =
      location.pathname.split("/")[location.pathname.split("/").length - 1];
    const regionName = ` ${getRegionNameByRegionId(
      regions,
      parseInt(stateId)
    )} | ${pagination.total} States`;
    return regionName;
  };
  const fetchBranchHeader = () => {
    const regionId =
      location.pathname.split("/")[location.pathname.split("/").length - 1];
    const regionName = ` ${getRegionNameByRegionId(
      states,
      parseInt(regionId)
    )} | ${pagination.total} Branches`;
    return regionName;
  };
  const resetHandler = () => {
    const currentMonth = dayjs().startOf("month");
    const nextMonth = dayjs().endOf("month");
    const dates = [currentMonth, nextMonth];
    const obj = {
      streamIds:
        userInfo?.userStreams && userInfo?.userStreams[0] != undefined
          ? userInfo?.userStreams[0]
          : null,
      yearMonth: dates,
      chipFields: {
        streamIds:
          userInfo?.userStreams && userInfo?.userStreams[0] != undefined
            ? userInfo?.userStreams[0]
            : null,
        yearMonth: dates,
      },
    };
    setIsFilterApplied(false);
    setDates(dates);
    setFilterState(obj);
    applyFilter(obj);
  };
  const Reset = () => <Button onClick={resetHandler}>Reset</Button>;
  const newFilterState = JSON.parse(JSON.stringify(filterState));
  const chipsFields =
    newFilterState && removeEmptyFields(newFilterState.chipFields);
  delete newFilterState["chipFields"];
  const filterLength = Object.values(newFilterState).length;
  const backButtonHandler = () => {
    if (mode === "Branch") {
      navigate("/admin/faculties/states/" + extraInformation.selectedRegion, {
        replace: false,
        state: {
          selectedRegion: extraInformation.selectedRegion,
        },
      });
    } else if (mode === "State") {
      navigate("/admin/faculties/regions", {
        replace: false,
        state: {
          selectedStudent: null,
        },
      });
    } else {
      navigate("/admin/faculties/branches/" + extraInformation.selectedState, {
        replace: false,
        state: {
          selectedRegion: extraInformation.selectedRegion,
          selectedState: extraInformation.selectedState,
        },
      });
    }
  };
  const returnDate = (date: any) => {
    return date?.[0].format("MMM-YYYY") + " ~ " + date?.[1].format("MMM-YYYY");
  };
  return (
    <>
      <DrawerAntdComponent
        title={"Filters"}
        open={open}
        setOpen={setOpen}
        width={450}
        footer={
          <>
            <Space className="d-flex justify-content-start">
              <Button
                type="primary"
                onClick={() => {
                  setIsFilterApplied(true);
                  applyFilter(filterState);
                  setFacultyPerformance(filterState);
                }}
                className={"m-0"}
              >
                Apply
              </Button>
              {isFilterApplied ? <Reset /> : null}
              <Button onClick={() => setOpen(false)}>Close</Button>
            </Space>
          </>
        }
      >
        {" "}
        <FacultiesRegionsFilter
          setFilterState={setFilterState}
          filterState={filterState}
          dates={dates}
          setDates={setDates}
        />
        {mode != "State" && (
          <FacultiesBranchesFilter
            setFilterState={setFilterState}
            filterState={filterState}
            subjects={userInfo?.subjectsListing}
          ></FacultiesBranchesFilter>
        )}
      </DrawerAntdComponent>
      <HeadersComponent
        cardTitle={
          mode == "State"
            ? fetchStateHeader()
            : mode != "Branch"
            ? fetchBranchsHeader()
            : fetchBranchHeader()
        }
        backButtonHandler={backButtonHandler}
      >
        <Space>
          {filterLength > 0 && ["xxl", "xl", "lg"].includes(screen) && (
            <>
              {filterState.chipFields &&
                Object.keys(filterState.chipFields).map((ele: any) => {
                  return (
                    ele != "chipFields" && (
                      <Tag
                        style={{
                          textAlign: "center",
                          textTransform: "capitalize",
                        }}
                        key={ele}
                      >
                        {typeof chipsFields[ele] != "object"
                          ? chipsFields[ele]
                          : ele === "yearMonth"
                          ? returnDate(filterState[ele])
                          : filterState[ele]["label"]}
                      </Tag>
                    )
                  );
                })}
            </>
          )}
          <Badge count={filterLength ? filterLength : 0}>
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
              }}
            >
              Filters
            </Button>
          </Badge>
          {isFilterApplied ? <Reset /> : null}
        </Space>
      </HeadersComponent>
    </>
  );
};

export default FacultiesBranchesHeader;
